import React from 'react';
import Logo from '../Logo';
import data from '../logos/first-direct.js';

const LogoFirstDirect = (props) => (
  <Logo style={{ backgroundColor: '#000' }} {...props} data={data} />
);

LogoFirstDirect.displayName = 'LogoFirstDirect';

export default LogoFirstDirect;
